module.exports = __webpack_public_path__ + "media/recipes/31-feca90d3.png";